import {
  CarFareInterface,
  TripsOfResumeItineraryVesselsInterface,
} from '../itineraries/types';
import { StopInterface } from '../stops/types';

/*
 * Action Types
 */
export enum publicStoreTypes {
  SET_TO_PAY_DATA = '@publicStore/SET_TO_PAY_DATA',
  SET_STEP = '@publicStore/SET_STEP',
  SET_RESCHEDULE_DATA = '@publicStore/SET_RESCHEDULE_DATA',
  SET_IS_CREATE_PROFILE = '@publicStore/SET_IS_CREATE_PROFILE',

  TICKET_SALES_LOGIN_REQUEST = '@users/TICKET_SALES_LOGIN_REQUEST',
  TICKET_SALES_LOGIN_SUCCESS = '@users/TICKET_SALES_LOGIN_SUCCESS',
  TICKET_SALES_LOGIN_FAILURE = '@users/TICKET_SALES_LOGIN_FAILURE',
}

export interface PassagerInterface {
  name: string;
  document: string;
}
export interface StepDataInterface {
  selected: boolean;
  completed: boolean;
  name: string;
  secondName?: string;
  toShow: boolean;
}

export interface RescheduleDataInterface {
  vehicleType: string;
  amount: number;
  reschedule: number | null;
  tokenId: string;
  passengers: number;
  startStopId: string;
  endStopId: string;
  profileId: string;
}

export interface ItineraryListInterface
  extends TripsOfResumeItineraryVesselsInterface {
  boardingTax?: number;
  boardingTaxRules?: {
    type: 'FIXED_VALUE' | 'PERCENTAGE';
    values: [
      {
        valueType: 'FIXED_VALUE' | 'PERCENTAGE';
        value: number;
        from: number | null;
        to: number | null;
      },
    ];
  };
  thereAreVacancies: boolean;
  toShow: boolean;
  startStop?: { id: string };
  endStop?: { id: string };
  holdTokens?: {
    holdToken?: string;
    tripScheduleSeatId?: string;
    profileId: string;
    profileName: string;
    value?: number;
    floor?: number;
    type: number;
    seatNumber?: number;
    tripScheduleId?: string;
  }[];
}

export interface TicktDataInterface {
  selectedDay: Date | null;
  date: { go: null | string; back: null | string } | null;
  selectedTravelGo: ItineraryListInterface | null;
  selectedTravelBack: ItineraryListInterface | null;
  finalStop: StopInterface | null;
  initialStop: StopInterface | null;
  isGoAndBack: boolean;
  seatType: number;
  profiles: {
    id: string;
    paymentTypeSingleTicket?: string;
    name: string;
    fare: { go: number; back: number; goBase: number; backBase: number };
    fareTax: { go: number; back: number; goBase: number; backBase: number };
    fareRules: {
      operation: string;
    };
    passengers: number;
    passengersInsideTheCar: number;
    holdToken: string;
    tripScheduleSeatId: string;
  }[];
  carFares: { go: CarFareInterface[]; back: CarFareInterface[] };
  carFareTaxes: { go: CarFareInterface[]; back: CarFareInterface[] };
  ticketType: string;
  license?: string;
  brand?: string;
  model?: string;
  vehycleType?: string;
}
export interface StepsInterface {
  go: StepDataInterface;
  back: StepDataInterface;
  details: StepDataInterface;
  confirmRescheduling: StepDataInterface;
  pay: StepDataInterface;
}

/*
 * State type
 */
export interface publicStoreState {
  readonly ticketData: TicktDataInterface;
  readonly step: StepsInterface;
  readonly rescheduleData: RescheduleDataInterface;
  readonly isCreateProfile: boolean;
  readonly wrongParams: null | { key: string; message: string };
}
